import * as React from 'react';

import { EventFieldOptions, ReportType } from '../api/clients';

import ErrorOverlay from '../../components/ErrorOverlay';
import LoadingOverlay from '../../components/LoadingOverlay';
import useGetEventReportFieldOptions from '../api/hooks/event-report/useGetEventReportFieldOptions';

const FlightOperationNotificationFieldOptionsContext = React.createContext<EventFieldOptions>(undefined!);

// eslint-disable-next-line max-len
export function FlightOperationNotificationFieldOptionsProvider({ children }: { children: React.ReactNode }): JSX.Element {
  const flightOperationNotificationFieldOptions = useGetEventReportFieldOptions(ReportType.FlightOperationNotification);

  if (flightOperationNotificationFieldOptions.isLoading) {
    return (
      <LoadingOverlay />
    );
  }

  if (flightOperationNotificationFieldOptions.status === 'error') {
    return (
      <ErrorOverlay
        title={flightOperationNotificationFieldOptions?.error?.title}
        message="An error occurred retrieving data"
      />
    );
  }

  if (flightOperationNotificationFieldOptions.data) {
    return (
      <FlightOperationNotificationFieldOptionsContext.Provider value={flightOperationNotificationFieldOptions.data}>
        {children}
      </FlightOperationNotificationFieldOptionsContext.Provider>
    );
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <React.Fragment />;
}

export const useFlightOperationNotificationFieldOptions = () => React.useContext(FlightOperationNotificationFieldOptionsContext);
